document.addEventListener("DOMContentLoaded", function() {

    // Custom modal logic for order again
    function showOrderAgainModal(message, callback, redirectOnClose) {
        var modal = document.getElementById('orderAgainModal');
        var msgDiv = document.getElementById('orderAgainModalMsg');
        var closeBtn = document.getElementById('orderAgainModalClose');
        window._orderAgainModalOpen = false;
        if (!modal || !msgDiv || !closeBtn) {
            alert(message); // fallback if modal not found
            if (callback) callback();
            if (redirectOnClose) window.location.href = '/cart';
            return;
        }
        msgDiv.textContent = message;
        modal.style.display = 'flex';
        window._orderAgainModalOpen = true;
        function blockNavigation(e) {
            if (window._orderAgainModalOpen) {
                e.preventDefault();
                e.returnValue = '';
                return '';
            }
        }
        window.addEventListener('beforeunload', blockNavigation);
        window.addEventListener('popstate', blockNavigation);
        var origAssign = window.location.assign;
        var origReplace = window.location.replace;
        window.location.assign = function(url) {
            if (window._orderAgainModalOpen) return;
            return origAssign.call(window.location, url);
        };
        window.location.replace = function(url) {
            if (window._orderAgainModalOpen) return;
            return origReplace.call(window.location, url);
        };
        function closeHandler(e) {
            if (e) e.stopPropagation();
            modal.style.display = 'none';
            closeBtn.removeEventListener('click', closeHandler);
            window._orderAgainModalOpen = false;
            window.removeEventListener('beforeunload', blockNavigation);
            window.removeEventListener('popstate', blockNavigation);
            window.location.assign = origAssign;
            window.location.replace = origReplace;
            if (callback) callback();
            if (redirectOnClose) window.location.href = '/cart';
        }
        closeBtn.addEventListener('click', closeHandler);
    }

    // Variant table logic as a function
    function runVariantTableLogic() {
        var variantsSection = document.querySelector('.product-information--variants');
        if (!variantsSection) return;
        var table = variantsSection.querySelector('.ck-table-resized');
        if (!table) return;
        var rows = table.querySelectorAll('tr');
        if (!rows || rows.length < 2) return;
        var secondRowTds = Array.from(rows[1].querySelectorAll('td')).map(function(td) {
            return td.textContent.trim();
        });
        for (var i = 2; i < rows.length; i++) {
            var tds = rows[i].querySelectorAll('td');
            for (var j = 0; j < tds.length; j++) {
                if (!tds[j].querySelector('.ck-inserted-value')) {
                    var span = document.createElement('span');
                    span.className = 'ck-inserted-value';
                    span.textContent = secondRowTds[j] || '';
                    tds[j].insertBefore(span, tds[j].firstChild);
                }
            }
        }
    }

    // Only run variant table logic if section exists
    if (document.querySelector('.product-information--variants')) {
        runVariantTableLogic();
    }



    // Direct event attachment for buy again button
    var buttons = document.querySelectorAll(".order-again-btn");

    buttons.forEach(function(btn) {
        function orderAgainHandler(e) {
            if (btn.disabled) return;
            btn.disabled = true;
            e.preventDefault();
            e.stopPropagation();
            console.log('btnclick', e);
            var itemsRaw = btn.getAttribute('data-order-items');
            var items;
            try {
                items = JSON.parse(itemsRaw);
            } catch (err) {
                showOrderAgainModal('Kunne ikke læse ordredata.', function() {
                    btn.disabled = false;
                    btn.addEventListener("click", orderAgainHandler, { once: true });
                });
                return;
            }
            if (!Array.isArray(items) || items.length === 0) {
                showOrderAgainModal('Ingen varer i denne ordre.', function() {
                    btn.disabled = false;
                    btn.addEventListener("click", orderAgainHandler, { once: true });
                });
                return;
            }
            // Separate available and unavailable items
            var availableItems = [];
            var unavailableTitles = [];
            items.forEach(function(item) {
                if (item.quantity > item.in_stock) {
                    var titleText = item.title ? item.title : ('variant ID ' + item.id);
                    unavailableTitles.push('"' + titleText + '"');
                } else {
                    availableItems.push(item);
                }
            });
            if (unavailableTitles.length > 0) {
                showOrderAgainModal(
                    'Følgende produkter har ikke nok på lager og blev ikke tilføjet til kurven: ' + unavailableTitles.join(', '),
                    function() {
                        btn.disabled = false;
                        btn.addEventListener("click", orderAgainHandler, { once: true });
                    },
                    availableItems.length > 0 // redirect if anything was added
                );
                if (availableItems.length > 0) {
                    addNext(0);
                }
            } else {
                addNext(0);
            }

            function addNext(index) {
                if (index >= availableItems.length) {
                    // Only show 'added to cart' modal if there are NO unavailable items
                    if (unavailableTitles.length === 0) {
                        showOrderAgainModal(
                            'Varerne er nu tilføjet til kurven.',
                            function() {
                                btn.disabled = false;
                                btn.addEventListener("click", orderAgainHandler, { once: true });
                            },
                            true // always redirect after success
                        );
                    } else {
                        // If there were unavailable items, just re-enable button (no modal, no redirect)
                        btn.disabled = false;
                        btn.addEventListener("click", orderAgainHandler, { once: true });
                    }
                    return;
                }
                var item = availableItems[index];
                var payload = { id: item.id, quantity: item.quantity };
                console.log('Adding to cart:', payload);
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                })
                .then(function(response) {
                    console.log('Cart add response:', response);
                    if (!response.ok) {
                        response.text().then(function(text) {
                            console.error('Cart add error response:', text);
                        });
                        throw new Error('Fejl ved tilføjelse til kurv');
                    }
                    return response.json();
                })
                .then(function(data) {
                    console.log('Cart add success:', data);
                    addNext(index + 1);
                })
                .catch(function(error) {
                    console.error('Cart add fetch error:', error);
                    showOrderAgainModal('Fejl ved tilføjelse af en vare til kurven.', function() {
                        btn.disabled = false;
                        btn.addEventListener("click", orderAgainHandler, { once: true });
                    });
                });
            };
            /* addNext(0); */
        }
        btn.addEventListener("click", orderAgainHandler, { once: true });
    });

});